import(/* webpackMode: "eager" */ "/opt/build/repo/apps/client/src/app/sign-up/[[...sign-up]]/page.tsx");
